import { type GridRowId } from "@mui/x-data-grid-pro";
import { useApiClient } from "../../../hooks/useApiClient";
import { toast } from "react-toastify";
import * as Sentry from "@sentry/react";
import { isAxiosError } from "axios";

interface ZipDownloadUrlAPIResponse {
  zipFileUri: string | null;
}

const ZIP_STATUS_STILL_CREATING = "still creating";
// 一部書類が公開待機中でZIPを配布できない状態（コンソーシアム由来の登記の遅延表示）
const ZIP_STATUS_CONSORTIUM_DELAYED = "consortium delayed";

export const useZipDownloadUrl = (): {
  handleDownload: (id: GridRowId) => Promise<void>;
} => {
  const { apiClient } = useApiClient();
  const handleDownload = async (id: GridRowId): Promise<void> => {
    try {
      const { data } = await apiClient.get<ZipDownloadUrlAPIResponse>(
        `/picture-request/${id}/zip-download-url`
      );

      if (
        data.zipFileUri?.startsWith("https://") === true ||
        data.zipFileUri?.startsWith("http://") === true
      ) {
        window.open(data.zipFileUri, "_blank", "noopener,noreferrer");
      } else if (data.zipFileUri === ZIP_STATUS_STILL_CREATING) {
        toast.info(
          <>
            一括ダウンロード用のファイルを作成中です。
            <br />
            これには数分かかる場合があります。
          </>
        );
      } else if (data.zipFileUri === ZIP_STATUS_CONSORTIUM_DELAYED) {
        toast.info(
          <>
            取得されて間もない一部の登記が含まれているため、現在この一括ダウンロードはご利用いただけません。
            <br />
            一定期間の経過後にダウンロードできるようになります。
          </>
        );
      } else {
        toast.error(
          <>
            ダウンロードに失敗しました
            <br />
            時間をおいて再度お試しください。
          </>
        );
      }
    } catch (error) {
      if (
        isAxiosError<ZipDownloadUrlAPIResponse>(error) &&
        error.response?.status === 404
      ) {
        toast.warning("ダウンロードできるファイルがありません。");
        return;
      }
      Sentry.captureException(error);
      toast.error(
        <>
          ダウンロードに失敗しました
          <br />
          時間をおいて再度お試しください。
        </>
      );
    }
  };

  return { handleDownload };
};
